import React from "react";
import styled, { css } from "styled-components";
import * as Tabs from "@radix-ui/react-tabs";

import Modal from "../../../Modal";
import { rem } from "polished";
import Button, { ButtonWrapper } from "../../../Button";
import ListItem from "../ListItem";
import { useDispatch, useSelector } from "react-redux";
import {
  addAccessories,
  getAccessories,
  removeAccessories,
} from "../../../../lib/redux/slices/accessories-slice";
import ItemDetailModal from "../ItemDetailModal";
import { useUpdateCart } from "../../../../hooks/use-update-cart";
import { IconClose } from "../../../Icons/IconClose";
import ItemActionHandle from "../../Fields/ItemActionHandle";

const Accessories = ({ data }) => {
  const [open, onSetModal] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [openDetailModal, onSetDetailModal] = React.useState(false);

  const accessories = useSelector(getAccessories);
  const dispatch = useDispatch();
  const { updateCart } = useUpdateCart();

  if (!data) return void 0;

  const removeSelected = (selectedIndex) => {
    const remainingItems = accessories.filter(
      (_, index) => index !== selectedIndex
    );
    dispatch(removeAccessories(remainingItems));
    updateCart((storeData) => ({
      ...storeData,
      accessories: remainingItems,
    }));
  };

  const attachAccessories = (attachAccessories) => {
    setSelectedItem(attachAccessories);
    dispatch(addAccessories(attachAccessories));
    updateCart((storeData) => ({
      ...storeData,
      accessories: [...storeData.accessories, attachAccessories],
    }));
  };

  return (
    <Layout>
      {accessories.length ? (
        <AccessoriesList
          data={accessories}
          removeSelected={removeSelected}
          openDetailModal={openDetailModal}
          onSetDetailModal={onSetDetailModal}
          setSelectedItem={setSelectedItem}
        />
      ) : null}

      <ButtonWrapper>
        <Button onClick={() => onSetModal(!open)}>VÄLJ</Button>
      </ButtonWrapper>
      <Modal
        wrapperId={`modal`}
        isOpen={open}
        overlayClick
        handleClose={() => onSetModal(false)}
        styles={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={data.label}
      >
        {data && (
          <ListItem
            data={data.options}
            onHandleSet={attachAccessories}
            onModalClose={() => onSetModal(false)}
            setSelectedItem={setSelectedItem}
            onSetDetailModal={onSetDetailModal}
            selectedItem={selectedItem}
          />
        )}
      </Modal>
      <ItemDetailModal
        selectedItem={selectedItem}
        openDetailModal={openDetailModal}
        onSetDetailModal={onSetDetailModal}
      />
    </Layout>
  );
};
export default Accessories;

const AccessoriesList = ({
  data,
  removeSelected,
  openDetailModal,
  onSetDetailModal,
  setSelectedItem,
}) => {
  return (
    <AccessoriesListLayout>
      {data.map((item, i) => {
        return (
          <ItemActionHandle 
            className="item" 
            key={i} 
            image={item.image} 
            title={item.name} 
            itemEvent={() => {
              onSetDetailModal(!openDetailModal);
              setSelectedItem(item);
            }}
            removeEvent={() => removeSelected(i)}
          />
        );
      })}
    </AccessoriesListLayout>
  );
};

const Layout = styled.div``;
const AccessoriesListLayout = styled.div`
  ${({ theme }) => css`
    .item {
      margin-bottom: ${rem(20)};
    }
  `}
`;
